const primary = '#845c3c';
const primaryLight = '#9b7455';
const secondary = '#242c64';
const secondaryLight = '#5c5c8c';
const primaryDark = '#393a40';
const secondaryDark = '#4f5460';

const success = '#34346c';
const successLight = '#4f5460';

const error = '#F44336';
const errorLight = '#E57373';
const warning = '#FF9800';

export const colors = {
    primary,
    primaryLight,
    primaryDark,
    secondary,
    secondaryLight,
    secondaryDark,
    success,
    successLight,
    error,
    errorLight,
    warning,
};